// @owm/widgets — рендереры слоёв, общие для оверлея и панели.
//
// Общие намеренно: предпросмотр в панели обязан выглядеть так же,
// как эфир. Два независимых рендерера разошлись бы на первой же
// правке, и расхождение обнаружилось бы тем, что модератор поставил
// слой по одному, а зритель увидел другое.
export { intersectsFrame, WidgetPropsError } from './contract.js';
export { Host } from './host.js';
export { embedWidget, EMBED_LOAD_TIMEOUT_MS, EMBED_STATE_EVENT, FORBIDDEN_SANDBOX, } from './embed.js';
export { Clock, clock, serverNow, setClock } from './clock.js';
export { familyFor, fontsReady, registerFont, resetFonts, watchFonts, whenFontsReady, FALLBACK_FAMILY, } from './fonts.js';
export { bufferBytes, imageBytes, setWarmCache, warmCache, WarmCache, WARM_BUDGET_BYTES, } from './warm.js';
export { audioGraph, setAudioGraph, WebAudioGraph } from './audio.js';
export { duckWindow, SoundPlayer, DEFAULT_DUCK_MS, DUCK_TAIL_MS, DUCK_TO } from './sound.js';
export { imageWidget } from './image.js';
export { videoWidget } from './video.js';
export { applyTextStyle, parseTextStyle, textWidget, MAX_FAMILY, MAX_TEXT } from './text.js';
export { format, remaining, timerWidget, TICK_MS } from './timer.js';
export { labelText, progressWidget, ratio } from './progress.js';
export { cameraWidget, CameraWall } from './camera.js';
export { shapeWidget, sketchLayer, MAX_POINTS } from './shape.js';
import { cameraWidget } from './camera.js';
import { embedWidget } from './embed.js';
import { imageWidget } from './image.js';
import { progressWidget } from './progress.js';
import { timerWidget } from './timer.js';
import { videoWidget } from './video.js';
import { shapeWidget } from './shape.js';
import { textWidget } from './text.js';
/**
 * Примитивы, доступные с самого начала.
 *
 * Список закрытый: неизвестный тип слоя хост не создаёт, а сообщает
 * об ошибке. Молча пропускать значило бы, что слой не появился
 * и никто не понял почему.
 */
export const primitives = [
    imageWidget,
    textWidget,
    shapeWidget,
    // Эмбед стоит в одном ряду с примитивами, хотя содержимым мы
    // не владеем: хосту он такой же слой, а список типов закрытый —
    // неизвестный тип не рисуется вовсе
    embedWidget,
    videoWidget,
    // Таймер и полоса — тоже примитивы: мы владеем их рендером
    // целиком. Таймер при этом единственный, кто движется сам,
    // и движется он МЕСТНЫМ тиком от серверной метки, а не
    // сообщениями по сети (docs/04)
    timerWidget,
    progressWidget,
    // Камера модератора: рендер наш — холст, — а картинка приходит
    // транзиентом и рисуется в него снаружи (см. CameraWall)
    cameraWidget,
];
//# sourceMappingURL=index.js.map